const ROOT_FOLDER_INDEX_NAME = 'root';

export type FolderPathFields = {
  name?: string;
  full_path?: string;
};

export const ROOT_FOLDER_TITLE_MESSAGE = {
  id: 'DocumentsFolderId.rootFolderTitle',
  defaultMessage: 'Documents',
  description: 'Title shown for the root Documents folder',
} as const;

export function displayFolderName(
  folder: FolderPathFields | null | undefined,
  documentsLabel: string,
): string {
  if (!folder) {
    return '';
  }
  if (folder.name === ROOT_FOLDER_INDEX_NAME) {
    return documentsLabel;
  }
  return folder.name ?? '';
}

export function displayFolderPath(
  folder: FolderPathFields | null | undefined,
  documentsLabel: string,
): string {
  if (!folder) {
    return '';
  }
  const trimmed = (folder.full_path ?? '').replace(/^\/+/, '');
  const isIndexedRoot =
    folder.name === ROOT_FOLDER_INDEX_NAME ||
    trimmed === ROOT_FOLDER_INDEX_NAME;
  if (isIndexedRoot) {
    return documentsLabel;
  }
  if (!trimmed) {
    return folder.name ?? '';
  }
  const withoutRootPrefix = trimmed.startsWith(`${ROOT_FOLDER_INDEX_NAME}/`)
    ? trimmed.slice(ROOT_FOLDER_INDEX_NAME.length + 1)
    : trimmed;
  return `${documentsLabel}/${withoutRootPrefix}`;
}
